import { render, staticRenderFns } from "./BcbCampaignAssignReviewers.vue?vue&type=template&id=25b9b1d2"
import script from "./BcbCampaignAssignReviewers.vue?vue&type=script&lang=js"
export * from "./BcbCampaignAssignReviewers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports